import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class GetBijbEventSuccessAction implements Action {
  public static readonly type = 'GetBijbEventSuccessAction';

  constructor(public bijbEvent: BijbEvent) {
  }

  public type = GetBijbEventSuccessAction.type;
}
